import moment from 'moment-jalaali';
import React from 'react';
import persianNumbers from '../../api/persianNumber';

function CoachReport({
  coachReport,
  proteinAmount,
  fatAmount,
  carbsAmount,
  maintainCalorie,
  allCoachReport,
}) {
  return (
    <div className="w-full mb-1">
      {/* Main Report Section */}
      <div className=" bg-base-200 mb-1  rounded-box">
        {/* <input type="checkbox" id="main-report" defaultChecked /> */}

        <div className="p-1">
          <div className="my-2">
            {/* <div className="text-gray-900 font-bold text-xl mb-2">
              پاسخ مربی
            </div> */}
            {/* <div className="text-sm">
              <span
                className={`${
                  coachReport?.rate === 1
                    ? 'bg-yellow-200'
                    : coachReport?.rate === 2
                    ? 'bg-sky-500'
                    : 'bg-orange-600'
                } text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded`}>
                {coachReport?.rate === 1
                  ? 'عالی'
                  : coachReport?.rate === 2
                  ? 'خوب'
                  : 'متوسط'}
              </span>
            </div> */}
            <div className="flex flex-col lg:flex-row justify-between m-1">
              <span className="text-sm mb-5 p-6 bg-white border rounded-lg shadow lg:w-2/3">
                <div className="text-gray-900 font-bold text-xl mb-2">
                  پاسخ مربی
                </div>
                <div className=""> {coachReport.next_Goal}</div>
              </span>
              <div className="max-w-sm lg:w-1/3 p-2 bg-white border rounded-lg shadow">
                <span className="text-md font-bold m-1 text-blue-400">
                  کالری تثبیت:
                  {persianNumbers(maintainCalorie)} کیلوکالری
                </span>{' '}
                <hr />
                <div className="text-gray-900 font-bold text-xl mb-2">
                  اهداف تغذیه ای هفته آینده
                  <br />
                  <span className="text-xs m-1 text-blue-400">
                    در اپ کالری شماری وارد شوند
                  </span>
                </div>
                <ul className="text-right text-gray-700">
                  <li>
                    <span className="text-md font-bold m-1 text-blue-400">
                      کالری روزانه:
                    </span>{' '}
                    {persianNumbers(coachReport?.calories)} کیلوکالری
                  </li>
                  <hr />
                  <ul className="list-disc list-inside">
                    <li>
                      <span className="text-md font-bold m-1 text-blue-400">
                        پروتیین:
                      </span>{' '}
                      {persianNumbers(coachReport?.protein)}%{' '}
                      {proteinAmount !== 0 && (
                        <span>({persianNumbers(proteinAmount)} گرم)</span>
                      )}
                    </li>
                    <hr />
                    <li>
                      <span className="text-md font-bold m-1 text-blue-400">
                        کربوهیدرات:
                      </span>{' '}
                      {persianNumbers(coachReport?.carbs)}%{' '}
                      {carbsAmount !== 0 && (
                        <span>({persianNumbers(carbsAmount)} گرم)</span>
                      )}
                    </li>
                    <hr />
                    <li>
                      <span className="text-md font-bold m-1 text-blue-400">
                        چربی :
                      </span>{' '}
                      {persianNumbers(coachReport?.fat)}%{' '}
                      {fatAmount !== 0 && (
                        <span>({persianNumbers(fatAmount)} گرم)</span>
                      )}
                    </li>
                    <hr />
                  </ul>
                  <li>
                    <span className="text-md font-bold m-1 text-blue-400">
                      فیبر:
                    </span>{' '}
                    {persianNumbers(coachReport?.fiber)} گرم
                  </li>
                  <hr />
                  <br />
                  <div className="text-gray-900 font-bold text-xl mb-2">
                    اهداف ورزشی هفته آینده
                    <br />
                  </div>
                  <ul className="list-disc list-inside">
                    <li>
                      <span className="text-md font-bold m-1 text-blue-400">
                        میانگین قدمهای روزانه:
                      </span>{' '}
                      {persianNumbers(coachReport?.steps)} قدم در روز
                    </li>
                    <hr />

                    <li>
                      <span className="text-md font-bold m-1 text-blue-400">
                        ورزش قدرتی:
                      </span>{' '}
                      {persianNumbers(coachReport?.exercise)} روز در هفته
                    </li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Past Reports */}
      {allCoachReport.map((item, i) => (
        <div key={i} className="collapse collapse-plus bg-base-200 mb-3">
          <input type="checkbox" id={`report-${i}`} />
          <label
            className="collapse-title text-xl font-medium"
            htmlFor={`report-${i}`}>
            گزارش{' '}
            {new Intl.DateTimeFormat('fa-IR', {
              dateStyle: 'short',
            }).format(new Date(item?.response_date))}
          </label>
          <div className="collapse-content">
            <p>{item?.next_Goal || 'No details provided'}</p>
            <ul className="text-right text-gray-700">
              {/* <li>
                <span>کالری تثبیت:</span> {item?.maintainCalorie} کیلوکالری
              </li> */}
              <hr />
              <li>
                <span>کالری:</span> {item?.calories} کیلوکالری
              </li>
              <hr />
              <li>
                <span>پروتیین:</span> {item?.protein}%{' '}
              </li>
              <hr />
              <li>
                <span>کربوهیدرات:</span> {item?.carbs}%{' '}
              </li>
              <hr />
              <li>
                <span>چربی:</span> {item?.fat}%{' '}
              </li>
              <hr />
              <li>
                <span>فیبر:</span> {item?.fiber} گرم
              </li>
              <hr />
              <li>
                <span>میانگین قدمهای روزانه:</span> {item?.steps} قدم در روز
              </li>
              <hr />
              <li>
                <span>ورزش قدرتی:</span> {item?.exercise} روز در هفته
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CoachReport;
